






















import { Component, Vue, Prop } from 'vue-property-decorator'
@Component

export default class AlbumCover extends Vue {
  hideAlbum: any = [1633, 1632]
  @Prop() album: any
  @Prop({ default: true }) showCount: boolean
  mounted() {
  }
  get playCount() {
    if (this.$route.query.from === 'qr' && this.hideAlbum.includes(+this.album.id)) {
      return this.album.actual_play_count > 9999 ? `${(this.album.actual_play_count / 10000).toFixed(1)}万` : this.album.actual_play_count
    } else {
      return this.album.play_count > 9999 ? `${(this.album.play_count / 10000).toFixed(1)}万` : this.album.play_count
    }
  }
  get commentCount() {
    return this.album.audios.reduce((sum, item) => sum + JSON.parse(item.comment_count), 0)
  }
}
